import { z } from '@harvestiq/zod';
import { dbCampaignInsertSchema } from './db-campaigns';
import { LivestockInsuranceTypes } from '@harvestiq/constants';

// TODO: split between LRP and LGM
export const createCampaignRequestSchema = dbCampaignInsertSchema
  .omit({
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
  })
  .extend({
    recipientIds: z.array(z.string().uuid()).optional(), // TODO: remove once cleaning up ENABLE_SMS_CAMPAIGNS
    sendEmailIds: z.array(z.string().uuid()).optional(),
    sendSmsIds: z.array(z.string().uuid()).optional(),
  })
  .superRefine((values, ctx) => {
    // when LRP targetWeight is required
    if (
      values.insuranceType === LivestockInsuranceTypes.LRP &&
      !values.targetWeight
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Target weight is required for LRP campaigns.',
      });
    }

    if (
      !values.recipientIds?.length &&
      !values.sendEmailIds?.length &&
      !values.sendSmsIds?.length
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'At least one recipient is required.',
      });
    }
  });

export type CreateCampaignRequest = z.input<typeof createCampaignRequestSchema>;
